module.exports = __webpack_public_path__ + "static/media/joshua.9749b3d8.jpeg";